import { Errors } from '../errors';
export function validateConstruct(sec, axClass, argc) {
    if (!axClass || !axClass.axConstruct) {
        var name_1 = axClass && axClass.classInfo ?
            axClass.classInfo.instanceInfo.getName().name :
            'value';
        sec.throwError('TypeError', Errors.ConstructOfNonFunctionError, name_1);
    }
    var methodInfo = axClass.classInfo.getInitializer();
    if (argc < methodInfo.minArgs) {
        sec.throwError('ArgumentError', Errors.WrongArgumentCountError, axClass.classInfo.instanceInfo.getName().name, methodInfo.minArgs, argc);
    }
}
